import { useState, useCallback, useEffect } from 'react';

export interface ValidationRule {
  required?: boolean;
  minLength?: number;
  maxLength?: number;
  pattern?: RegExp;
  custom?: (value: any, formData?: any) => boolean;  // Updated this line
  message: string;
}

export interface ValidationRules {
  [key: string]: ValidationRule[];
}

export const useFormValidation = <T extends object>(rules: ValidationRules) => {
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [isValid, setIsValid] = useState(false);

  const validate = useCallback((data: T): boolean => {
    const newErrors: { [key: string]: string } = {};

    Object.keys(rules).forEach((field) => {
      const value = data[field as keyof T];
      const fieldRules = rules[field];

      for (const rule of fieldRules) {
        // Check for required fields, allowing 0 as a valid value
        if (rule.required && (value === undefined || value === null || value === '')) {
          newErrors[field] = rule.message;
          break;
        }
        if (rule.custom && !rule.custom(value, data)) {
          newErrors[field] = rule.message;
          break;
        }
      }
    });

    setErrors(newErrors);
    const valid = Object.keys(newErrors).length === 0;
    setIsValid(valid);
    return valid;
  }, [rules]);

  return { errors, validate, isValid };
};